module.exports = __webpack_public_path__ + "img/brace.74b4d80e.png";